import { PaletteColor, Theme } from "@mui/material";

// New file: messagePriority.tsx
export enum MessagePriority {
  Regular = 0,
  Success = 20,
  Info = 40,
  Warning = 60,
  Error = 80,
}

export function getMessagePriorityName(priority: number | MessagePriority): string {
  switch (priority) {
    case MessagePriority.Success:
      return "Sucesso (verde)";
    case MessagePriority.Info:
      return "Informação (azul)";
    case MessagePriority.Warning:
      return "Aviso (amarelo)";
    case MessagePriority.Error:
      return "Problema (vermelho)";
    case MessagePriority.Regular:
    default:
      return "Normal";
  }
}

export function getMessagePriorityColor(theme: Theme, priority: number | MessagePriority): PaletteColor {
  switch (priority) {
    case MessagePriority.Success:
      return theme.palette.success;
    case MessagePriority.Info:
      return theme.palette.info;
    case MessagePriority.Warning:
      return theme.palette.warning;
    case MessagePriority.Error:
      return theme.palette.error;
    case MessagePriority.Regular:
    default:
      return theme.palette.primary;
  }
}

export const MESSAGE_PRIORITIES: { id: MessagePriority; name: string; color: string | null }[] = [
  { id: MessagePriority.Regular, name: "Normal", color: null },
  { id: MessagePriority.Success, name: "Sucesso", color: "success" },
  { id: MessagePriority.Info, name: "Informação", color: "info" },
  { id: MessagePriority.Warning, name: "Aviso", color: "warning" },
  { id: MessagePriority.Error, name: "Problema", color: "error" },
];
